import axios from 'axios';
import qs from 'qs';

const api = axios.create({
	baseURL: '/_api/',
	paramsSerializer: function(params) {
		return qs.stringify(params, { arrayFormat: 'repeat' });
	}
});

api.interceptors.response.use(
	function(response) {
		// Do something with response data
		return response;
	},
	function(error) {
		if (error.response.status === 403 || error.response.status === 401) {
			window.location.href = `/dashboard/logout`;
		}

		// Do something with response error
		return Promise.reject(error);
	}
);

export default api;



// WEBPACK FOOTER //
// ./app/services/api.js